module.exports = __webpack_public_path__ + "static/media/entering_chatham.f5569e45.jpg";